import React from 'react';
import { Card } from '@/components/UI/components/Card';
import RevHub from '@/assets/images/RevHub.svg';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
}
const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <div className="min-h-screen w-full flex flex-col justify-start items-center bg-fixed bg-gradient-to-r from-cyan-200 to-purple-600 p-4 sm:p-12 lg:p-18 xl:p-24 dark:from-cyan-950 dark:to-purple-950">
      <Card className="sm:max-w-md max-sm:rounded-none bg-[#010550] border-none shadow-none ring-none">
        <div className="flex items-center justify-center py-4 sm:pt-12 sm:pt-6">
          <img src={RevHub} alt="RevHub" className="w-48 lg:w-64" />
        </div>
        {title && (
          <h1 className="text-lg text-center text-revving-content-inverted dark:text-darkRevving-content-inverted pb-8">
            {title}
          </h1>
        )}
        {children}
      </Card>
    </div>
  );
};

export default AuthLayout;
